export default {
  eudrBatches: [],
  loading: false
}
